import { DataLayerItem } from '../../StoreDetails/types'

export const parseAdditionalFilterParameters = (
  parameters?: string
): Record<string, string> => {
  if (!parameters?.trim()) {
    return {}
  }

  const normalizedParameters = parameters.trim().replace(/^[?&]+/, '')

  return Object.fromEntries(
    Array.from(new URLSearchParams(normalizedParameters).entries()).filter(
      ([key]) => key
    )
  )
}

export const buildDataLayerStoreSearch = (
  displayName: string
): DataLayerItem[] => {
  if (!displayName) {
    return []
  }
  return [
    { key: 'event', value: 'search' },
    { key: 'searchType', value: 'Suggested' },
    { key: 'searchQuery', value: displayName ?? '' }
  ]
}

export const buildDataLayerFilterClick = ({
  groupName,
  filterCode,
  filterLabel
}: {
  groupName?: string
  filterCode?: string
  filterLabel?: string
}): DataLayerItem[] => {
  return [
    { key: 'event', value: 'storeLocatorFilter' },
    { key: 'storeLocatorFilterCategory', value: groupName ?? '' },
    { key: 'storeLocatorFilterFilterID', value: filterCode ?? '' },
    { key: 'storeLocatorFilterName', value: filterLabel ?? '' }
  ]
}
